module.exports = require('lodash').toPath